/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum RegistrationStatus {
    IN_PROGRESS = 'in_progress',
    SUBMITTED = 'submitted',
    CANCELED = 'canceled',
    IN_CART = 'in_cart',
    DELETED = 'deleted',
    CHECKOUT = 'checkout',
}
